import store from 'state/store'
import { getBackendHost } from 'utils/backendApi/getBackendHost'

const arrayBufferToBase64 = buffer => {
  var binary = ''
  var bytes = new Uint8Array(buffer)
  var len = bytes.byteLength
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return window.btoa(binary)
}

export const request = async (url, method = 'get', body = {}, extraHeaders = {}, binaryMode = false) => {
  const currentState = store.getState()
  const { ui = {}, auth = {} } = currentState

  const { inOrgMode } = ui

  const { token, organization, selectedYard, yardId } = auth

  const options = {
    method,
    headers: new Headers({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      Organization: organization,
      Yard: inOrgMode ? 'ORG_MODE' : selectedYard,
      yardId,
      Build: __COMMIT_HASH__,
      ...extraHeaders,
    }),
  }

  if (method.toLowerCase() === 'post' || method.toLowerCase() === 'put') {
    options.body = JSON.stringify(body)
  }
  const baseUrl = getBackendHost(url)

  const response = await fetch(`${baseUrl}${url}`, options)
  if (binaryMode) {
    const blob = await response.blob()
    const arrayBuffer = await blob.arrayBuffer()
    return arrayBufferToBase64(arrayBuffer)
  } else {
    return await response.json()
  }
}
